import axios from 'axios'
import qs from 'qs'
import fn from '../../utils/functions'
import dayjs from 'dayjs';

// Normaliza fechas en profundidad para evitar que qs.stringify destruya objetos Dayjs
export function convertDates(obj) {
  if (obj == null) return obj;

  // Detecta Day.js correctamente
  if (dayjs.isDayjs(obj)) {
    return obj.toISOString();
  }

  // Detecta Date nativo
  if (obj instanceof Date) {
    return obj.toISOString();
  }

  // Arrays → recorrer
  if (Array.isArray(obj)) {
    return obj.map(item => convertDates(item));
  }

  // Objetos → recorrer recursivamente
  if (typeof obj === 'object') {
    const newObj = {};
    for (const key in obj) {
      newObj[key] = convertDates(obj[key]);
    }
    return newObj;
  }

  
  return obj;
}

const DEFAULT_ARTICLES_SORT = ['creationDateTime,ASC']

function initSession () {
  const session = {
    articles: {
      tableData: [],
      totalItems: 0
    },
    queryArticles: {
      page: 0,
      size: 20,
      sort: DEFAULT_ARTICLES_SORT,
      creationDateTimeFrom: fn.initDateFrom(3),
      creationDateTimeTo: fn.initDateTo(),
      id: null,
      idSeller: [],
      idBuyer: [],
      itemCode: null,
      itemDescription: null,
      futureGrossPriceDateFrom: null,
      futureGrossPriceDateTo: null,
      enable: null,
      pendingUpdate: null
    },
    listSelectedFiltersArticles: [],
    optionFilterBuyerArticles: [],
    optionFilterSellerArticles: [],
    optionFilterItemCodeArticles: [],
    optionFilterItemDescriptionArticles: [],
    optionFilterGrossPriceArticles: [],
    optionFilterFutureGrossPriceDateArticles: [],
    optionFilterFutureGrossPriceArticles: []
  }
  return session
}
function setByUserLocalArticles () {
  const store = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
  const local = {
    isShowSellerName: store?.articles?.isShowSellerName ?? true,
    isShowBuyerName: store?.articles?.isShowBuyerName ?? true,
    isShowItemCode: store?.articles?.isShowItemCode ?? true,
    isShowItemDescription: store?.articles?.isShowItemDescription ?? true,
    isShowGrossPrice: store?.articles?.isShowGrossPrice ?? true,
    isShowFutureGrossPriceDate: store?.articles?.isShowFutureGrossPriceDate ?? true,
    isShowFutureGrossPrice: store?.articles?.isShowFutureGrossPrice ?? true,
    isShowCreationDateTime: store?.articles?.isShowCreationDateTime ?? true,
    isShowEnable: store?.articles?.isShowEnable ?? true
  }
  return local
}

const state = {
  userConfigLocalStorage: '',
  local: {
    isShowSellerName: true,
    isShowBuyerName: true,
    isShowItemCode: true,
    isShowItemDescription: true,
    isShowGrossPrice: true,
    isShowFutureGrossPriceDate: true,
    isShowFutureGrossPrice: true,
    isShowCreationDateTime: true,
    isShowEnable: true
  },
  session: initSession()
}

const getters = {
  queryArticles: state => state.session.queryArticles,
  articles: state => state.session.articles,
  listSelectedFiltersArticles: state => state.session.listSelectedFiltersArticles,
  optionFilterBuyerArticles: state => state.session.optionFilterBuyerArticles,
  optionFilterSellerArticles: state => state.session.optionFilterSellerArticles,
  optionFilterItemCodeArticles: state => state.session.optionFilterItemCodeArticles,
  optionFilterItemDescriptionArticles: state => state.session.optionFilterItemDescriptionArticles,
  optionFilterGrossPriceArticles: state => state.session.optionFilterGrossPriceArticles,
  optionFilterFutureGrossPriceDateArticles: state => state.session.optionFilterFutureGrossPriceDateArticles,
  optionFilterFutureGrossPriceArticles: state => state.session.optionFilterFutureGrossPriceArticles,
  isShowSellerName: state => state.local.isShowSellerName,
  isShowBuyerName: state => state.local.isShowBuyerName,
  isShowItemCode: state => state.local.isShowItemCode,
  isShowItemDescription: state => state.local.isShowItemDescription,
  isShowGrossPrice: state => state.local.isShowGrossPrice,
  isShowFutureGrossPriceDate: state => state.local.isShowFutureGrossPriceDate,
  isShowFutureGrossPrice: state => state.local.isShowFutureGrossPrice,
  isShowCreationDateTime: state => state.local.isShowCreationDateTime,
  isShowEnable: state => state.local.isShowEnable
}

const actions = {
  setUserNameArticles ({ state }) {
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalArticles()
    }
  },

  async isNewVersionArticlesLocalState ({ state }, localStorageObj) {
    const isnew =  fn.isNewVersion(state, localStorageObj.articles)
    return isnew
  },

  async getArticles ({ commit, rootState }, data) {
    try {
      const query = buildArticlesQuery(data?.query)
      const response = await axios({
        method: 'GET',
        url: '/article',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: query,
        paramsSerializer: (p) => qs.stringify(convertDates(p))
      })
      commit('ARTICLES_STATE', {
        tableData: response.data.content,
        totalItems: response.data.totalElements
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      throw error?.response || error
    }
  },

  async createArticle ({ commit, rootState }, { idSeller, idBuyer, itemCode, itemDescription, grossPrice, futureGrossPriceDate, futureGrossPrice, enable }) {
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/article',
        data: { idSeller, idBuyer, itemCode, itemDescription, grossPrice, futureGrossPriceDate, futureGrossPrice, enable }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.error('createArticle error:', error.response || error)
      throw error.response || error
    }
  },

  async updateArticle ({ commit, rootState }, { id, itemDescription, grossPrice, futureGrossPriceDate, futureGrossPrice }) {
    try {
      const response = await axios({
        method: 'PUT',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: `/article/${id}`,
        data: { itemDescription, grossPrice, futureGrossPriceDate, futureGrossPrice }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.error('updateArticle error:', error.response || error)
      throw error.response || error
    }
  },

  async updateEnableArticle ({ commit, rootState }, { id, enable }) {
    try {
      const response = await axios({
        method: 'PUT',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: `/article/${id}/enabled`,
        data: { enable }
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.error('updateEnableArticle error:', error.response || error)
      throw error.response || error
    }
  },

  articlesState: ({ commit }, payload) => {
    commit('ARTICLES_STATE', payload)
  },
  queryArticlesState: ({ commit }, payload) => {
    commit('QUERY_ARTICLES_STATE', payload)
  },
  listSelectedFiltersArticlesState: ({ commit }, payload) => {
    commit('LIST_SELECTED_FILTERS_ARTICLES_STATE', payload)
  },

  // Setters combos filtros
  optionFilterBuyerArticlesState: ({ commit }, payload) => { commit('OPTION_FILTER_BUYER_ARTICLES', payload) },
  optionFilterSellerArticlesState: ({ commit }, payload) => { commit('OPTION_FILTER_SELLER_ARTICLES', payload) },
  optionFilterItemCodeArticlesState: ({ commit }, payload) => { commit('OPTION_FILTER_ITEM_CODE_ARTICLES', payload) },
  optionFilterItemDescriptionArticlesState: ({ commit }, payload) => { commit('OPTION_FILTER_ITEM_DESCRIPTION_ARTICLES', payload) },
  optionFilterGrossPriceArticlesState: ({ commit }, payload) => { commit('OPTION_FILTER_GROSS_PRICE_ARTICLES', payload) },
  optionFilterFutureGrossPriceDateArticlesState: ({ commit }, payload) => { commit('OPTION_FILTER_FUTURE_GROSS_PRICE_DATE_ARTICLES', payload) },
  optionFilterFutureGrossPriceArticlesState: ({ commit }, payload) => { commit('OPTION_FILTER_FUTURE_GROSS_PRICE_ARTICLES', payload) },

  isShowSellerNameAction: ({ commit }, payload) => { commit('IS_SHOW_SELLER_NAME', payload) },
  isShowBuyerNameAction: ({ commit }, payload) => { commit('IS_SHOW_BUYER_NAME', payload) },
  isShowItemCodeAction: ({ commit }, payload) => { commit('IS_SHOW_ITEM_CODE', payload) },
  isShowItemDescriptionAction: ({ commit }, payload) => { commit('IS_SHOW_ITEM_DESCRIPTION', payload) },
  isShowGrossPriceAction: ({ commit }, payload) => { commit('IS_SHOW_GROSS_PRICE', payload) },
  isShowFutureGrossPriceDateAction: ({ commit }, payload) => { commit('IS_SHOW_FUTURE_GROSS_PRICE_DATE', payload) },
  isShowFutureGrossPriceAction: ({ commit }, payload) => { commit('IS_SHOW_FUTURE_GROSS_PRICE', payload) },
  isShowCreationDateTimeAction: ({ commit }, payload) => { commit('IS_SHOW_CREATION_DATE_TIME', payload) },
  isShowEnableAction: ({ commit }, payload) => { commit('IS_SHOW_ENABLE', payload) }
}

const mutations = {
  'QUERY_ARTICLES_STATE' (state, payload) {
    state.session.queryArticles = payload
  },
  'ARTICLES_STATE' (state, payload) {
    state.session.articles = payload
  },
  'LIST_SELECTED_FILTERS_ARTICLES_STATE' (state, payload) {
    state.session.listSelectedFiltersArticles = payload
  },
  'OPTION_FILTER_BUYER_ARTICLES' (state, payload) {
    state.session.optionFilterBuyerArticles = payload
  },
  'OPTION_FILTER_SELLER_ARTICLES' (state, payload) {
    state.session.optionFilterSellerArticles = payload
  },
  'OPTION_FILTER_ITEM_CODE_ARTICLES' (state, payload) {
    state.session.optionFilterItemCodeArticles = payload
  },
  'OPTION_FILTER_ITEM_DESCRIPTION_ARTICLES' (state, payload) {
    state.session.optionFilterItemDescriptionArticles = payload
  },
  'OPTION_FILTER_GROSS_PRICE_ARTICLES' (state, payload) {
    state.session.optionFilterGrossPriceArticles = payload
  },
  'OPTION_FILTER_FUTURE_GROSS_PRICE_DATE_ARTICLES' (state, payload) {
    state.session.optionFilterFutureGrossPriceDateArticles = payload
  },
  'OPTION_FILTER_FUTURE_GROSS_PRICE_ARTICLES' (state, payload) {
    state.session.optionFilterFutureGrossPriceArticles = payload
  },
  'IS_SHOW_SELLER_NAME' (state, payload) {
    state.local.isShowSellerName = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage)) || {}
    storeuser.articles = storeuser.articles || {}
    storeuser.articles.isShowSellerName = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_BUYER_NAME' (state, payload) {
    state.local.isShowBuyerName = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage)) || {}
    storeuser.articles = storeuser.articles || {}
    storeuser.articles.isShowBuyerName = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ITEM_CODE' (state, payload) {
    state.local.isShowItemCode = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage)) || {}
    storeuser.articles = storeuser.articles || {}
    storeuser.articles.isShowItemCode = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ITEM_DESCRIPTION' (state, payload) {
    state.local.isShowItemDescription = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage)) || {}
    storeuser.articles = storeuser.articles || {}
    storeuser.articles.isShowItemDescription = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_GROSS_PRICE' (state, payload) {
    state.local.isShowGrossPrice = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage)) || {}
    storeuser.articles = storeuser.articles || {}
    storeuser.articles.isShowGrossPrice = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_FUTURE_GROSS_PRICE_DATE' (state, payload) {
    state.local.isShowFutureGrossPriceDate = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage)) || {}
    storeuser.articles = storeuser.articles || {}
    storeuser.articles.isShowFutureGrossPriceDate = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_FUTURE_GROSS_PRICE' (state, payload) {
    state.local.isShowFutureGrossPrice = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage)) || {}
    storeuser.articles = storeuser.articles || {}
    storeuser.articles.isShowFutureGrossPrice = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CREATION_DATE_TIME' (state, payload) {
    state.local.isShowCreationDateTime = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage)) || {}
    storeuser.articles = storeuser.articles || {}
    storeuser.articles.isShowCreationDateTime = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ENABLE' (state, payload) {
    state.local.isShowEnable = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage)) || {}
    storeuser.articles = storeuser.articles || {}
    storeuser.articles.isShowEnable = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'SELLER_OPTIONS_STATE' (state, payload) {
    state.session.sellerOptions = payload
  },
  'BUYER_OPTIONS_STATE' (state, payload) {
    state.session.buyerOptions = payload
  },
  'resetSessionArticles' (state) {
    state.session = initSession()
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}

// Helper interno para normalizar la query y reducir complejidad en getArticles
function buildArticlesQuery (q = {}) {
  const isBool = (v) => typeof v === 'boolean'
  const asArray = (v) => Array.isArray(v) ? v : []
  const normalizeSort = (sort) => {
    if (!sort || (Array.isArray(sort) && sort.length === 0)) return DEFAULT_ARTICLES_SORT
    return Array.isArray(sort) ? sort : [sort]
  }

  return {
    page: q.page ?? 0,
    size: q.size ?? 20,
    sort: normalizeSort(q.sort),
    id: q.id ?? null,
    idSeller: asArray(q.idSeller),
    idBuyer: asArray(q.idBuyer),
    itemCode: q.itemCode ?? null,
    itemDescription: q.itemDescription ?? null,
    itemCodeOrDescription: q.itemCodeOrDescription ?? null,
    creationDateTimeFrom: q.creationDateTimeFrom ?? null,
    creationDateTimeTo: q.creationDateTimeTo ?? null,
    futureGrossPriceDateFrom: q.futureGrossPriceDateFrom ?? null,
    futureGrossPriceDateTo: q.futureGrossPriceDateTo ?? null,
    enable: isBool(q.enable) ? q.enable : null,
    pendingUpdate: isBool(q.pendingUpdate) ? q.pendingUpdate : null
  }
}

